import { render, staticRenderFns } from "./FormularioPlantaFabril.vue?vue&type=template&id=71eebef0&lang=pug"
import script from "./FormularioPlantaFabril.vue?vue&type=script&lang=js"
export * from "./FormularioPlantaFabril.vue?vue&type=script&lang=js"
import style0 from "./FormularioPlantaFabril.vue?vue&type=style&index=0&id=71eebef0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports